import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

import { ActionModel } from '@models/admin/action.model';
import { MessageModel } from '@models/message.model';
import { CompareService } from '@services/admin/compare.service';
import { TableConductorService } from '@services/admin/table-conductor.service';

@Injectable({
  providedIn: 'root',
})
export class MessageHandlerService {
  private readonly messageService = inject(MessageService);
  private readonly compareService = inject(CompareService);
  private readonly tableConductorService = inject(TableConductorService);

  handle(message: MessageModel): void {
    const actions = message.actions ?? [];
    const messageActions: ActionModel[] = [];

    actions.forEach((action) => {
      if (action.actionType === 'tableUpdate' && action.name) {
        this.tableConductorService.updateTable(action.name);
      } else {
        messageActions.push(action);
      }
    });

    const visibleActions = this.filterActions(messageActions);

    this.addMessage({
      ...message,
      actions: visibleActions,
    });
  }

  private filterActions(actions: ActionModel[]): ActionModel[] {
    return actions.filter((action) => !this.compareService.checkForMessageAction(action, 'hide'));
  }

  private addMessage(message: MessageModel): void {
    if (!message.message && !message.title && !message.actions?.length) return;

    this.messageService.add({
      severity: message.type,
      summary: message.title,
      detail: message.message,
      data: message.actions,
      life: Math.max(0, Number(message.life ?? 6)) * 1000,
      closable: true,
    });
  }
}
